var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"searchbar-container"},[_c('input',{attrs:{"autocomplete":"off","placeholder":"Search for DHR, Assemblies, LOT's, ..."},domProps:{"value":_vm.newVal},on:{"input":function($event){return _vm.updateField($event)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }